exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body-item[data-v-1573cf32]{overflow:hidden;position:relative;margin-top:15px}.body-title[data-v-1573cf32]{background:#e87b92;padding:6px;position:absolute;color:#fff;margin-left:15px}.body-content[data-v-1573cf32]{line-height:30px;font-size:15px;min-height:70px;border:1px solid #ddd;border-radius:5px;margin-top:15px;padding-top:27px;padding-left:15px;padding-bottom:19px;overflow:hidden}.demo-upload-list[data-v-1573cf32]{display:inline-block;width:130px;height:130px;text-align:center;border:1px solid transparent;border-radius:4px;overflow:hidden;background:#fff;position:relative;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.2);box-shadow:0 1px 1px rgba(0,0,0,.2);margin-right:4px}.demo-upload-list img[data-v-1573cf32]{width:100%;height:100px;display:block;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1573cf32","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/medDocs/index.vue
// module id = oA5E
// module chunks = 0